import { useGetMembersPlacesByPlaceId, usePrefetch } from "@birdwatch/client";
import { useCallback } from "react";

import { useMyPlaceContext } from "@/features/my/_providers/my-place-context-provider";

/**
 * Warms the detail of every home the member could switch to, for a switcher to call
 * when it opens. A member has a handful of homes, so this is a handful of small reads,
 * and the switch that follows commits without waiting on the network.
 */
export function usePrefetchMyPlaces() {
  const prefetch = usePrefetch();
  const { placeId, places } = useMyPlaceContext();

  return useCallback(() => {
    for (const place of places) {
      if (place.id === placeId) continue;
      void prefetch(useGetMembersPlacesByPlaceId({ placeId: place.id }));
    }
  }, [placeId, places, prefetch]);
}
